import { Box, IconButton, useMediaQuery } from "@mui/material";
import { useRef, useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const EMOJIS = [
  // ✅ 가장 인기 있는 이모지 (Top 5)
  "😂", // 유쾌함, 웃김
  "❤️", // 공감, 좋아요
  "😭", // 강한 슬픔
  "🔥", // 인상적, 핫이슈
  "👍", // 찬성

  // ✅ 감정 표현 (공감, 반응)
  "😊", // 흐뭇함, 긍정
  "🥲", // 슬픈 공감
  "😡", // 분노
  "😐", // 무표정, 냉담
  "😍", // 감탄

  // ✅ 반응 및 평가
  "👎", // 반대
  "👏", // 박수
  "💯", // 전적인 동의
  "🎉", // 축하

  // ✅ 생각, 의견, 놀람
  "🤔", // 생각
  "😮", // 놀람
  "🙄", // 어이없음
  "🤷", // 모름
  "😎", // 멋짐

  // ✅ 협력, 의사소통, 액션
  "🙏", // 감사, 요청
  "🤝", // 협력
  "📢", // 주장
  "💬", // 대화
  "❗", // 강조
  "💡", // 아이디어
  "⛔", // 금지
  "🗳️", // 투표

  // ✅ 메타적, 보조적
  "🎯", // 핵심
  "💥", // 충돌
  "😇", // 선의
  "🧠", // 지성

  // ✅ 자연 요소 (과일 + 나무)
  "🍎", // 사과
  "🍌", // 바나나
  "🍒", // 체리
  "🌳", // 나무
  "🌴", // 야자수
];

export default function EmojiSwiper({
  commentInput,
  setCommentInput,
  inputRef,
  cursorRef,
  session,
}: {
  commentInput: string;
  setCommentInput: (val: string) => void;
  inputRef: React.RefObject<HTMLTextAreaElement | null>;
  cursorRef: React.RefObject<number | null>;
  session: any;
}) {
  const theme = useTheme();
  const scrollRef = useRef<HTMLDivElement>(null);

  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));

  const scrollBy = (amount: number) => {
    scrollRef.current?.scrollBy({ left: amount, behavior: "smooth" });
  };

  // 커서 위치 업데이트
  useEffect(() => {
    if (!inputRef.current || cursorRef.current == null) return;
    inputRef.current.selectionStart = cursorRef.current;
    inputRef.current.selectionEnd = cursorRef.current;
    inputRef.current.focus();
  }, [commentInput]); // commentInput이 업데이트되면 커서 적용

  const handleInsertEmoji = (emoji: string) => {
    const input = inputRef.current;
    if (!input) return;

    const start = input.selectionStart ?? 0;
    const end = input.selectionEnd ?? 0;
    const newValue = commentInput.slice(0, start) + emoji + commentInput.slice(end);
    setCommentInput(newValue);
    cursorRef.current = start + emoji.length;
  };

  return (
    <Box display="flex" alignItems="center" gap={0.5} py={0.1} width={"100%"}>
      {isMdUp && (
        <IconButton size="small" onClick={() => scrollBy(-120)}>
          <ChevronLeftIcon fontSize="small" />
        </IconButton>
      )}

      <Box
        ref={scrollRef}
        sx={{
          display: "flex",
          overflowX: "auto",
          gap: 0.53,
          px: 0.5,
          scrollBehavior: "smooth",
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": { display: "none" },
        }}
      >
        {EMOJIS.map((emoji) => (
          <IconButton key={emoji} size="small" disabled={!session} onClick={() => handleInsertEmoji(emoji)}>
            <span style={{ fontSize: "1.2rem" }}>{emoji}</span>
          </IconButton>
        ))}
      </Box>

      {isMdUp && (
        <IconButton size="small" onClick={() => scrollBy(200)}>
          <ChevronRightIcon fontSize="small" />
        </IconButton>
      )}
    </Box>
  );
}
